import {Component, EventEmitter, inject, input, Input, OnInit, Output} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {InputOtpModule} from 'primeng/inputotp';
import {FormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {AuthService} from 'src/app/shared/services/auth.service';
import {Router} from '@angular/router';
import {ErrorInterface} from 'src/app/shared/interfaces/global';
//import { MatFormField } from '@angular/material/form-field';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-confirmation',
  imports: [
    TranslateModule,
    InputOtpModule,
    FormsModule,
    InputTextModule,
    //MatFormField,
    MatCheckbox,
  ],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss',
  standalone: true,
})
export class ConfirmationComponent implements OnInit {
  @Output() setNewPassword = new EventEmitter();
  @Output() showNewTelPage = new EventEmitter();

  private $auth = inject(AuthService);
  private $router = inject(Router);
  private $ts = inject(TranslateService);

  //0-почта, 1-телефон
  loginType = input.required<0 | 1>();
  payload = input.required<string>();
  country_id = input.required<number>();
  is_recovery = this.$auth.is_recovery;


  code = '';
  resend = true;
  timer = 100;
  handle: any;
  codeError = false;
  short_session = false;
  has_attempts = true;
  errorMessage: ErrorInterface | null = null;

  callPassword = this.$auth.callPassword;

  ngOnInit() {
    this.focusOnOtp();
    clearInterval(this.handle);
    this.handle = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        clearInterval(this.handle);
        this.resend = false;
        this.timer = 100;
      }
    }, 1000);
  }

  resendCode(): void {
    this.$auth
      .getCodeAuth(!!this.loginType(), this.payload(), this.country_id())
      .subscribe({
        next: (res) => {
          this.$auth.setTempToken(res.temporary_token);
          this.resend = true;
          clearInterval(this.handle);
          this.codeError = false;
          this.has_attempts = true;
          this.handle = setInterval(() => {
            this.timer--;
            if (this.timer === 0) {
              this.resend = false;
              this.timer = 100;
              clearInterval(this.handle);
            }
          }, 1000);
        },
        error: (res) => {
          this.errorMessage = res.error;
          this.has_attempts = res.error.status_code !== 429;
        },
      });
  }

  focusOnOtp() {
    setTimeout(() => {
      const otp = document.getElementById('otpElement');
      otp?.focus();
    });
  }

  sendCode() {
    if (this.is_recovery()) {
      this.$auth
        .resetVerifyCode(
          this.loginType(),
          this.payload(),
          this.code
        )
        .subscribe({
          next: (res) => {
            this.$auth.setTempToken(res.temporary_token);
            this.setNewPassword.emit();
          },
          error: (res: { error: ErrorInterface }) => {
            this.codeError = true;
            this.errorMessage = res.error;
            this.has_attempts = res.error.status_code !== 429;
          },
        });
    } else {
      this.$auth
        .verifyCode(this.loginType(), this.payload(), this.code, this.short_session)
        .subscribe({
          next: (res) => {
            this.$auth.setToken(res.access_token, res.refresh_token);
            this.$router.navigate(['/answer']).then();
          },
          error: (res: { error: ErrorInterface }) => {
            this.codeError = true;
            this.errorMessage = res.error;
            this.has_attempts = res.error.status_code !== 429;
          },
        });
    }
  }

  setCode() {
    if (
      (this.loginType() && this.code.length === 5) ||
      (!this.loginType() && this.code.length === 4)
    ) {
      this.sendCode();
    }
  }

  showNewTel() {
    if(this.is_recovery()) {
      this.$auth.callResetPasswordID(this.payload(), this.country_id(), this.$ts.getDefaultLang())
        .subscribe({
          next: (res) => {
            this.callPassword.set(res);
            this.showNewTelPage.emit();
          }
        })
    } else {
      this.$auth.callPasswordID(this.payload(), this.country_id(), this.$ts.getDefaultLang())
        .subscribe({
          next: (res) => {
            this.callPassword.set(res);
            this.showNewTelPage.emit();
          }
        })
    }
  }
}
